import React , { useState }from "react";
import { motion } from "framer-motion";
import { projectFirestore} from '../firebase/config';
import { Text, StyleSheet,Linking} from "react-native";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faClose, faUser} from '@fortawesome/free-solid-svg-icons'

const Modal = ({selectedImg, setSelectedImg}) => {

    const readInfoByImgUrl = async () => {
        const snapshot = await projectFirestore
          .collection("images")
          .limit(1)
          .where("url", "==", selectedImg)
          .get();
      
        const doc = snapshot.docs[0];

      
        const imageInfo = {
          id: doc.id,
          imageName: doc.data().imageName,
          artistLink: doc.data().artistLink,
          artistName: doc.data().artistName,
          artistProfileViewCount: doc.data().artistProfileViewCount,
        };
        setTitleText(imageInfo.imageName);
        setDescText("By "+imageInfo.artistName);
        setArtistLink(imageInfo.artistLink);
        setArtistProfileViewCount(imageInfo.artistProfileViewCount);
        setImageId(imageInfo.id);
       
        return imageInfo; 
      };

    const handleClick = (e) =>{
        if(e.target.classList.contains('backdrop')){
          setSelectedImg(null);
        }

        if(e.target.classList.contains('backdrop-closeBtn')){
          setSelectedImg(null);
       }
    }

    const handleCloseClick = (e) =>{
      setSelectedImg(null);
    }
    

    readInfoByImgUrl();

    const [titleText, setTitleText] = useState("...");

    const [descText, setDescText] = useState("");

    const [artistLink, setArtistLink] = useState(null);

    const [artistProfileViewCount, setArtistProfileViewCount] = useState(0);

    const [imageId, setImageId] = useState(null);

    const handleArtistProfileViewCount = (e) =>{
      var newAPVCount = artistProfileViewCount+1;
      projectFirestore.collection("images").doc(imageId).set({
        artistProfileViewCount: newAPVCount,
      }, { merge: true });
    }

    const onPressBtn = () => {
      Linking.openURL(artistLink).catch(err => console.error("Couldn't load page", err));
      handleArtistProfileViewCount();
    };

    return(
      
        <motion.div className="backdrop" onClick={handleClick}
            initial={{opacity:0}}
            animate={{opacity:1}}>

                <div className="backdrop-content">

                  <div className="backdrop-actionLayout" >

                    <div className="backdrop-profileBtn" onClick={onPressBtn}>

                      <FontAwesomeIcon icon={faUser} onClick={onPressBtn}></FontAwesomeIcon>

                    </div>

                    <div className="backdrop-closeBtn" onClick={handleClick}>

                      <FontAwesomeIcon icon={faClose} onClick={handleCloseClick}></FontAwesomeIcon>

                    </div>

                  </div>

                  <div className="backdrop-content-img-container">

                    <img src={selectedImg} alt="full details image" st />

                  </div>

                    <div class="backdrop-content-info">

                      <div className="backdrop-content-info-text">
                        <Text style={styles.titleText}>
                            {titleText}
                        </Text>

                        <Text style={styles.titleText}>
                            {"\n"}
                        </Text>

                        <Text style={styles.descText}>
                            {descText}
                        </Text>
                      </div>

                    </div>

                </div>

        </motion.div>
    )
}

  const styles = StyleSheet.create({
    titleText: {
      fontFamily: "roboto",
      fontSize: 20,
      color:"#092327",
      fontWeight: "bold"
    },
    descText: {
      fontFamily: "roboto",
      fontSize: 13,
      color:"#092327",
      fontWeight:"normal"
    }
  });

  

export default Modal;